<template>
<div class="sidebar">
    <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" :background-color="menuBarBackgroundColor" text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
        <template v-for="item in items">
            <template v-if="item.subs">
                <el-submenu :index="item.code" :key="item.code">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ displayTitle(item.code, item.title) }}</span>
                    </template>
                    <template v-for="subItem in item.subs">
                        <el-submenu v-if="subItem.subs" :index="subItem.code" :key="subItem.code">
                            <template slot="title">{{ displayTitle(subItem.code, subItem.title) }}</template>
                            <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.code">
                                {{ displayTitle(threeItem.code, threeItem.title) }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="subItem.code" :key="subItem.code + 1">{{ displayTitle(subItem.code, subItem.title) }} </el-menu-item>
                    </template>
                </el-submenu>
            </template>
            <template v-else>
                <el-menu-item :index="item.code" :key="item.code">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ displayTitle(item.code, item.title) }}</span>
                </el-menu-item>
            </template>
        </template>
    </el-menu>
</div>
</template>

<script>
import bus from '../common/bus';
import {
    SortField
} from '../../utils/helper';
export default {
    data() {
        return {
            collapse: false,
            items: [],
            menuBarBackgroundColor: '#324157',
            menuTextColor: '#bfcbd9'
        };
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    created() {
        this.getSystemInfo();
        this.getData();
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', (msg) => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
    mounted() {},
    methods: {
        displayTitle(code, title) {
            const codeKey = `menus.${code}`;
            if (this.$te && this.$te(codeKey)) {
                return this.$t(codeKey);
            }
            const titleKey = `menusTitles.${title}`;
            if (this.$te && this.$te(titleKey)) {
                return this.$t(titleKey);
            }
            return title;
        },
        getData() {
            let username = localStorage.getItem('ms_username');
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            if (username != undefined && username != null) {
                this.$zybhttp
                    .post('Menu/GetMenuLeft', {
                        Field1: userInfo.userType
                    })
                    .then((res) => {
                        if (res.data.status == 0) {
                            res = res.data;
                            var d = res.data.list;
                            var list = this.MenuCarding(d);
                            this.items = list;
                            this.items.push({
                                code: 'CoalTaxCalc',
                                icon: 'el-icon-s-finance',
                                title: '折算与税费测算'
                            });
                            this.items.push({
                                code: 'AlarmControl',
                                icon: 'el-icon-bell',
                                title: '报警消音控制'
                            });
                          //  this.items.push({
                          //      code: 'CoalEquipMonitor',
                          //      icon: 'el-icon-monitor',
                          //      title: '输煤设备状态监测'
                          //  });
                            this.items.push({
                                code: 'MTStandard',
                                icon: 'el-icon-document-checked',
                                title: 'MT1082标准报表',
                                subs: [{
                                    code: 'MTRealtimeList',
                                    title: '实时列表显示'
                                }, {
                                    code: 'MTSevereOverYearShow',
                                    title: '严重超产按年显示'
                                }, {
                                    code: 'MTSevereOverMonthShow',
                                    title: '严重超产按月显示'
                                }, {
                                    code: 'MTOverYearShow',
                                    title: '超产按年显示'
                                }, {
                                    code: 'MTOverMonthShow',
                                    title: '超产按月显示'
                                }, {
                                    code: 'MTOutputYearQuery',
                                    title: '产量按年查询显示'
                                }, {
                                    code: 'MTOutputMonthQuery',
                                    title: '产量按月查询显示'
                                }, {
                                    code: 'MTOutputDayQuery',
                                    title: '产量按日查询显示'
                                }, {
                                    code: 'MTAbnormalDisplay',
                                    title: '系统工作异常显示'
                                }]
                            });
                        } else {
                            this.$notify.error(res.message);
                        }
                    })
                    .catch((err) => this.$notify.error(this.$t('common.networkListError')));
            }
        },
        MenuCarding(data) {
            var menus = [];
            var d = JSON.parse(JSON.stringify(data));
            var dOne = d.filter((x) => x.parentId == 0);
            // var dOne = d.filter(function (e) {
            //     return e.parentId == 9999;
            // });
            var dOneSort = dOne.sort(SortField('sort', 'asc')).map((x) => {
                return {
                    id: x.id,
                    code: x.code,
                    icon: x.icon,
                    title: x.title
                };
            });
            menus = menus.concat(dOneSort);
            menus.forEach((x) => {
                var pid = x.id;
                var dtwo = d.filter((x) => x.parentId == pid);
                if (dtwo.length > 0) {
                    var dtwoSort = dtwo.sort(SortField('sort', 'asc')).map((x) => {
                        return {
                            id: x.id,
                            code: x.code,
                            icon: x.icon,
                            title: x.title
                        };
                    });
                    x.subs = dtwoSort;
                }
            });
            return menus;
        },
        getSystemInfo() {
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.version = d.msg;
                        this.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.menuTextColor = d.data.list[0].textColor;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('common.networkListError')));
        },
    }
};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}

.sidebar>ul {
    height: 100%;
}
</style>
